export const SHORTCUTS_SMART_LINKS_BEST_EFFORT_TASK_NAME =
	'SpaceShortcutsSpaceNavigationQueryWithORSResolver';
